"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var ExitFullScreen = function ExitFullScreen(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 402.995 402.996'
  }, props), /*#__PURE__*/_react["default"].createElement('g', null, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M232.025,182.955h134.667c5.521,0,10-4.477,10-10v-19.024c0-5.523-4.479-10-10-10h-78.046L400.067,32.51\r c3.903-3.905,3.903-10.237,0-14.142L386.614,4.915c-1.953-1.953-4.514-2.929-7.071-2.929s-5.119,0.977-7.071,2.929\r L261.051,116.336V38.289c0-5.522-4.478-10-10-10h-19.023c-5.522,0-10,4.478-10,10v134.666\r C222.025,178.478,226.503,182.955,232.025,182.955z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M114.351,143.931H36.305c-5.523,0-10,4.477-10,10v19.024c0,5.523,4.477,10,10,10h134.666c5.523,0,10-4.477,10-10V38.289\r c0-5.522-4.477-10-10-10h-19.024c-5.523,0-10,4.478-10,10v78.047L30.522,4.915c-1.952-1.953-4.512-2.929-7.07-2.929\r c-2.56,0-5.119,0.977-7.072,2.929L2.929,18.368c-3.905,3.905-3.905,10.237,0,14.142L114.351,143.931z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M232.025,374.707h19.023c5.523,0,10-4.477,10-10V286.66L372.47,398.082c3.905,3.904,10.238,3.904,14.145,0l13.452-13.453\r c3.903-3.905,3.903-10.237,0-14.143l-111.42-111.421h78.046c5.521,0,10-4.479,10-10v-19.024c0-5.521-4.479-10-10-10H232.025\r c-5.521,0-10,4.479-10,10v134.666C222.025,370.23,226.503,374.707,232.025,374.707z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M16.38,398.082c3.905,3.904,10.238,3.904,14.142,0L141.943,286.66v78.047c0,5.523,4.478,10,10,10h19.025\r c5.523,0,10-4.477,10-10V230.041c0-5.521-4.477-10-10-10H36.304c-5.522,0-10,4.479-10,10v19.024c0,5.521,4.478,10,10,10h78.047\r L2.929,370.486c-3.905,3.904-3.905,10.236,0,14.143L16.38,398.082z'
  })));
};
/* eslint-enable */
var _default = ExitFullScreen;
exports["default"] = _default;